<template>
  <Modal :show-modal="modalStatus" @cancel="closeModal">
    <template v-if="isOtpSent === false" v-slot:header>
      <p class="text-3xl font-bold text-main-color">{{ $t('page.welcome') }}</p>
    </template>
    <template v-if="isOtpSent === false" v-slot:content>
      <!-- <p class="text-start mb-4">{{ $t('page.register_account') }}</p> -->
      <div class="flex items-center justify-center flex-col px-10 mb-8 rounded-t">
        <p class="text-center text-base font-medium w-full">
          {{ $t('page.registerToContinue') }}
        </p>
      </div>
      <Form
        @submit="getFunction"
        class="flex flex-col gap-2"
        :validation-schema="isPhone ? schemaPhonePassword() : schemaEmailPassword()"
      >
        <!-- <div class="flex flex-col gap-1">
                        <label class="text-start font-bold text-main-color mb-2" for="password">{{ $t('form.username')
                            }}</label>
                        <Field v-model="formData.username"
                            class=" p-4 w-full z-10 text-main-color bg-white rounded  border border-gray-300 focus:outline-none  text-sm"
                            type="username" name="username" id="username"></Field>
                        <ErrorMessage name="username" class="text-red-500 text-start" />
                    </div> -->
        <template v-if="isEmail">
          <div class="flex flex-col gap-1">
            <label class="text-start font-bold text-main-color mb-2" for="email">{{
              $t('form.email')
            }}</label>
            <Field
              v-model="formData.email"
              class="p-4 w-full z-10 text-main-color bg-white rounded border border-gray-300 focus:outline-none text-sm"
              type="email"
              name="email"
              id="email"
            ></Field>

            <ErrorMessage name="email" class="text-red-500 text-start" />
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col gap-1">
            <label class="text-start font-bold text-main-color mb-2" for="phone">{{
              $t('form.phone')
            }}</label>
            <div class="flex items-center">
              <span
                class="flex-shrink-0 z-10 inline-flex items-center p-4 text-sm font-bold text-center text-white bg-main-color border border-main-color border-gray-300 rounded rounded-r-none"
              >
                +993
              </span>
              <div class="relative w-full">
                <Field
                  v-model="formData.phone"
                  class="block p-4 w-full z-10 text-main-color bg-white rounded border-s-0 border border-gray-300 focus:outline-none rounded-l-none text-sm"
                  type="phone"
                  name="phone"
                  id="phone"
                ></Field>
              </div>
            </div>
            <ErrorMessage name="phone" class="text-red-500 text-start" />
          </div>
        </template>
        <div class="flex flex-col gap-1">
          <label class="text-start font-bold text-main-color mb-2" for="password">{{
            $t('form.password')
          }}</label>
          <Field
            v-model="formData.password"
            class="p-4 w-full z-10 text-main-color bg-white rounded border border-gray-300 focus:outline-none text-sm"
            type="password"
            name="password"
            id="password"
          ></Field>
          <ErrorMessage name="password" class="text-red-500 text-start" />
        </div>

        <template v-if="isPhone">
          <p
            @click="
              () => {
                isPhone = false;
                isEmail = true;
              }
            "
            class="flex justify-center text-[#409DBA] font-bold text-lg cursor-pointer"
          >
            {{ $t('page.loginByEmail') }}
          </p>
        </template>
        <template v-else>
          <p
            @click="
              () => {
                isEmail = false;
                isPhone = true;
              }
            "
            class="flex justify-center text-[#409DBA] font-bold text-lg cursor-pointer"
          >
            {{ $t('page.loginByPhone') }}
          </p>
        </template>

        <SubmitBtn type="submit" class="!w-full mt-5">{{ $t('action.registerOrLogin') }}</SubmitBtn>
        <div class="flex items-center justify-between gap-2 mt-5 text-base">
          <p>{{ $t('page.alreadyHaveAccount?') }}</p>
          <button
            @click="openLoginModal"
            class="flex justify-center text-main-color hover:text-[#409DBA] cursor-pointer"
          >
            {{ $t('page.loginAccount') }}
          </button>
        </div>
      </Form>

      <!-- <button @click="toLogin" class="text-start">{{ $t('page.has_account') }} <span
                    class="text-gp-orange font-medium hover:text-gp-orange-red ease-linear transition-all duration-150">{{
        $t('action.login') }}</span></button> -->
    </template>
    <template v-if="isOtpSent == true" v-slot:header>{{ $t('page.verification_code') }}</template>
    <template v-if="isOtpSent == true" v-slot:content>
      <Form @submit="postLogin" class="flex flex-col gap-2">
        <p class="mb-2 text-main-color">{{ $t('page.verification_code_sent') }}</p>
        <OTPInput v-model="formData.code" class="my-2" :fields="6"></OTPInput>
        <!-- <div class="flex flex-col gap-1 mb-3">
					<label class="text-start text-main-color" for="code">{{ $t('page.verification_code') }}</label>
					<Field v-model.number="activationForm.code" class="flex px-4 py-4 rounded border border-solid border-gp-input-stroke bg-gp-input" type="text"
						name="code" id="code" pattern="\d*"></Field>
					<ErrorMessage name="code" class="text-red-500" />
				</div> -->
        <p v-if="countDown > 0" class="text-center font-medium mb-2">{{ countDown }}s</p>
        <button
          v-else
          @click="resendCode"
          class="mb-5 text-accent-color ease-linear transition-all duration-150"
        >
          {{ $t('page.resend_code') }}
        </button>
        <SubmitBtn type="submit" class="!w-full">{{ $t('action.verify') }}</SubmitBtn>
      </Form>

      <!-- <button @click="toLogin" class="text-start">{{ $t('page.no_account') }} <span
                    class="text-gp-orange font-medium hover:text-gp-orange-red ease-linear transition-all duration-150">{{
        $t('action.register') }}</span></button> -->
    </template>
  </Modal>
</template>

<script>
import IconUser from '@icons/IconUser.vue';
import OTPInput from '@cmp/OTPInput.vue';
import { schemaEmailPassword, schemaPhonePassword } from '@/schemas';
import { Field, Form, ErrorMessage } from 'vee-validate';
import api from '@/api';
import Modal from '@cmp/Modal.vue';
import { i18n } from '@/i18n';
import { useAppStore } from '@/store';
export default {
  name: 'RegisterModal',
  components: {
    IconUser,
    OTPInput,
    Field,
    Form,
    ErrorMessage,
    Modal,
  },

  data() {
    return {
      store: useAppStore(),
      loading: false,
      showModal: false,
      isOtpSent: false,
      isPhone: true,
      isEmail: false,
      isPassword: false,
      schemaEmailPassword: schemaEmailPassword,
      schemaPhonePassword: schemaPhonePassword,
      countDown: 60,
      formData: {
        username: null,
        code: null,
        email: null,
        phone: null,
        password: null,
      },
    };
  },
  methods: {
    openLoginModal() {
      this.closeModal();
      this.store.setState('loginModal', true);
    },
    closeModal() {
      // this.showModal = false
      this.isOtpSent = false;
      this.formData = {
        username: null,
        code: null,
        email: null,
        phone: null,
      };
      this.store.setState('registerModal', false);
    },
    resendCode() {
      if (this.isPhone) {
        this.sendCodePhone();
      } else {
        this.sendCodeEmail();
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    async postLogin() {
      try {
        const body = {
          password: this.formData.password,
          code: this.formData.code,
          username: this.formData.username,
        };
        const response = await api.post('token/', body);
        api.defaults.headers = {
          Authorization: 'Token ' + response.data.token,
          'Accept-Language': localStorage.getItem('lang') || 'tk',
        };
        this.store.setAuthOnLogin(response.data);
        await this.store.getUserData();
        this.closeModal();

        if (this.$route.query.redirect_url) {
          this.$router.push({ path: this.$route.query.redirect_url });
        } else {
          if (this.store.userData?.has_business_account) {
            this.$router.push({ path: '/profile/myBusinessPublications' });
          } else {
            this.$router.push({ path: '/profile/myPublications' });
          }
        }
        this.$toast.info(`${i18n.global.t('warning.LOGGED_IN')}`);
      } catch (e) {
        console.log(e);
      }
    },
    async sendCodePhone() {
      try {
        this.countDown = 60;
        this.countDownTimer();
        const response = await api.post('code/phone/', {
          phone: `+993${this.formData.phone}`,
          password: this.formData.password,
        });
        this.formData.username = `+993${this.formData.phone}`;
        this.isOtpSent = true;
      } catch (e) {
        console.log(e);
      }
    },
    async sendCodeEmail() {
      try {
        this.countDown = 60;
        this.countDownTimer();
        const response = await api.post('code/email/', {
          email: this.formData.email,
          password: this.formData.password,
        });
        this.formData.username = this.formData.email;
        this.isOtpSent = true;
      } catch (e) {
        console.log(e);
      }
    },
  },
  computed: {
    modalStatus() {
      return this.store.registerModal;
    },
    getFunction() {
      return this.isPhone ? this.sendCodePhone : this.sendCodeEmail;
    },
  },
  created() {},
};
</script>
